import 'regenerator-runtime/runtime';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import CheckoutRoutes from './routes/CheckoutRoutes';
import ScrollToTop from './components/ScrollToTop';

const container = document.getElementById('app-mountpoint');
const root = createRoot(container);
root.render(
  <BrowserRouter>
    <ScrollToTop />
    <div className="pressrelease pressrelease-create">
      <CheckoutRoutes />
    </div>
  </BrowserRouter>,
);
